<template>
    <div class="v-walk-inspections">
        <div class="start-page-wrap">
            <img src="@/assets/sign-in-bg.jpg" alt="image" class="main-img">
            <div class="bottom-content">
                <Button
                    text="ADD Campus Assessment"
                    rightImg="white-plus.png"
                    classBtn="add-inspection-btn"
                    :isActive="true"
                    :click="addNewCampus"
                />
                <div class="list-head">
                    <div class="left">
                        <div class="search-wrap">
                            <input
                                type="text"
                                class="search-inp"
                                placeholder="Search..."
                                v-model="searchValue"
                            >
                            <img src="@/assets/magnifier.png" alt="magnifier" class="magnifier-img">
                        </div>
                    </div>
                    <div class="right">
                        <span class="sort-text">Sort by</span>
                        <div
                            :class="`c-sort-item ${isSortByName}`"
                            @click="changeSortValue('byName')"
                        >
                            <span>Name</span>
                            <img src="@/assets/arrow-down.png" alt="arrow">
                        </div>
                        <div
                            :class="`c-sort-item ${isSortByDate}`"
                            @click="changeSortValue('byDate')"
                        >
                            <span>Date</span>
                            <img src="@/assets/arrow-down.png" alt="arrow">
                        </div>
                    </div>
                </div>
                <div class="inpections-list">
                    <div class="properties">
                        <ListItem
                            v-for="item in filteredItems"
                            :key="item.id"
                            :id="item.id"
                            :title="item.name"
                            :type="item.type"
                            :address="item.address"
                            :date="item.date"
                            :isInspected="isInspected"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "@/components/Button"
import ListItem from "./components/ListItem"
import { getCampusAssessments, createCampusAssessment } from "../../api/campus"

export default {
    data: function() {
        return {
            sortValue: "",
            searchValue: "",
            properties: [],
        }
    },
    components: {
        Button,
        ListItem,
    },
    async mounted() {
        try {
            let response = await getCampusAssessments()
            this.properties = response
        } catch (err) {
            console.error(err)
        }

        this.$store.commit("header/setData", {
            title: "Campus Assessments",
            showLogo: true,
            showPrevBtn: true,
            prevLink: "/start"
        })
    },
    computed: {
        isSortByName() {
            return this.sortValue === "byName" ? "active" : ""
        },
        isSortByDate() {
            return this.sortValue === "byDate" ? "active" : ""
        },
        isInspected() {
            return this.activeTab === "inspected"
        },
        propertiesTabState() {
            if(this.activeTab === "properties")
                return "active"

            return "" 
        },
        inspectedTabState() {
            if(this.activeTab === "inspected")
                return "active"

            return "" 
        },
        sortItems() {
            if (this.sortValue === "byName") {
                return this.properties.sort((a, b) => a.name.localeCompare(b.name))
            } else if (this.sortValue === "byDate") {
                return this.properties.sort((a, b) => {
                    let aDate = new Date(a.date).getTime()
                    let bDate = new Date(b.date).getTime()

                    return aDate - bDate
                })
            }

            return this.properties
        },
        filteredItems() {
            return this.sortItems.filter(item => item.name.toLowerCase().includes(this.searchValue.toLowerCase()))  
        },
    },
    methods: {
        changeSortValue(value) {
            this.sortValue = value
        },
        async addNewCampus() {
            try {
                let response = await createCampusAssessment({})
                
                this.$router.push(`/campus-assessment/add/${response.rid}/1`)
            } catch (err) {
                console.error(err)
            }
        },
    },
}
</script>

<style lang="sass">
@import ../../helpers/mixins

div.start-page-wrap
    max-width: 1000px
    margin: 0 auto
    padding-bottom: 50px

    div.properties
        margin-top: 30px

    img.main-img
        width: 100%
        height: 180px
        object-fit: cover

    div.bottom-content
        max-width: 800px
        margin: 0 auto
        padding: 0 15px

    button.add-inspection-btn
        margin-bottom: 20px
        margin-top: 32px

    div.list-head
        display: flex
        justify-content: space-between
        align-items: center
        +mobile(500px)
            flex-direction: column
            div.right,
            div.left
                width: 100%

        div.right
            display: flex
            align-items: center
            +mobile(500px)
                margin-top: 15px

        span.sort-text
            font-size: 12px

    div.search-wrap
        position: relative
        display: inline-block
        +mobile(500px)
            width: 100%
            input
                width: 100%

        input.search-inp
            padding: 11px 12px
            font-size: 18px
            outline: none
            border: 1px solid #FA0
            border-radius: 5px
            width: 290px

        input.search-inp::placeholder
            color: #CCC
            font-size: 18px
            font-weight: 300

        input.search-inp:focus
            box-shadow: 0px 1px 3px 0px #2178D5

        img.magnifier-img
            position: absolute
            top: 50%
            right: 12px
            transform: translateY(-50%)
            cursor: pointer

    div.tabs
        display: flex
        justify-content: space-around
        margin-top: 20px
        margin-bottom: 25px

        div.tab
            font-size: 16px
            line-height: 16px
            padding: 14px 16px
            text-transform: uppercase
            color: #434F5B
            box-shadow: 0px -1px 0px 0px #C6BD9D inset
            cursor: pointer
            transition: 0.1s
            &.active
                box-shadow: 0px -2px 0px 0px #124C7B inset
                color: #2178D5

    div.c-sort-item
        border-radius: 20px
        padding: 6px 12px
        margin: 0 6px
        display: flex
        justify-content: center
        align-items: center
        border: 1px solid #FA0
        text-transform: uppercase
        color: #124C7B
        font-size: 12px
        cursor: pointer
        transition: 0.1s

        &.active
            background: linear-gradient(0deg, rgba(255, 170, 0, 0.60) 0%, rgba(255, 170, 0, 0.60) 100%), #FFF
            img
                display: inline-block

        img
            margin-left: 7px
            display: none

</style>